module.exports = __webpack_public_path__ + "static/img/8.a219bee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/8.jpg
// module id = qYBe
// module chunks = 0